import React, { useState } from "react";
import { Modal, Button } from "@/components";
import styles from "./ChangeStatusModal.module.scss";

interface ChangeStatusModalProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onConfirm: () => void;
  isLoading?: boolean;
  modalVisibleContent: number;
  setModalVisibleContent: React.Dispatch<React.SetStateAction<number>>;
}

export const ChangeStatusModal: React.FC<ChangeStatusModalProps> = ({
  isOpen,
  setIsOpen,
  onConfirm,
  isLoading = false,
  modalVisibleContent,
  setModalVisibleContent,
}) => {

  const handleClose = () => {
    setModalVisibleContent(0);
    onConfirm();
  }

  return (
    <Modal
      title={modalVisibleContent === 0 ? "Вы точно хотите подать заявку?" : "Запрос отправлен!"}
      subTitle={modalVisibleContent === 0 ? "" : " Наш менеджер скоро с Вами свяжется для верификации в качестве организатора турниров."}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      closeModal={handleClose}
      modalWindowWidth={415}
      mobileContentSize="fixed"
    >
      {
        modalVisibleContent === 0 ? (
          <div className={styles.content}>
            <div className={styles.actions}>
              <Button
                onClickFunc={onConfirm}
                disabled={isLoading}
                newStyles={styles.buttonConfirm}
              >
                Отправить
              </Button>
              <Button
                onClickFunc={handleClose}
                disabled={isLoading}
                newStyles={styles.buttonCancel}
              >
                Отменить
              </Button>
            </div>
          </div>
        ) : (
          <div className={styles.content}>
            <div className={styles.info}>
              <p className={styles.phoneNumberLink}>
                Если вопрос срочный, можете позвонить по номеру:

                <a href="tel:+74951505599">
                  <span className={styles.phoneNumber}>
                    +7 (495) 150-55-99
                  </span>
                </a>
              </p>
            </div>
          </div>
        )
      }
    </Modal>
  );
};
